/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationreasonharassment2Inputs */

const en_moderationreasonharassment2 = /** @type {(inputs: Moderationreasonharassment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harassment`)
};

const de_moderationreasonharassment2 = /** @type {(inputs: Moderationreasonharassment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belästigung`)
};

/**
* | output |
* | --- |
* | "Harassment" |
*
* @param {Moderationreasonharassment2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationreasonharassment2 = /** @type {((inputs?: Moderationreasonharassment2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationreasonharassment2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationreasonharassment2(inputs)
	return de_moderationreasonharassment2(inputs)
});
export { moderationreasonharassment2 as "moderationReasonHarassment" }